/* The Pocket. Grid of look covers; clicking one opens every shot in that look
   at once, scrolled rather than paged.

   The URL carries the open look as a hash, so a look is linkable from Instagram
   and the browser back button closes the viewer instead of leaving the page. */

(function () {
  var viewer = document.querySelector('[data-pp-viewer]');
  if (!viewer) return;

  var stack = viewer.querySelector('[data-pp-viewer-stack]');
  var titleEl = viewer.querySelector('[data-pp-viewer-title]');
  var lastFocused = null;

  var dataFor = function (slug) {
    var el = document.querySelector('[data-pp-look-data="' + slug + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  var open = function (slug, pushState) {
    var data = dataFor(slug);
    if (!data || !data.images.length) return;
    lastFocused = document.activeElement;
    titleEl.textContent = data.title || '';

    stack.innerHTML = '';
    data.images.forEach(function (img, i) {
      var el = new Image();
      el.className = 'pp-viewer__img';
      el.src = img.src;
      if (img.w700 && img.w1000) {
        el.srcset = img.w700 + ' 700w, ' + img.w1000 + ' 1000w, ' + img.src + ' 1400w';
      }
      el.sizes = '(min-width: 750px) 46vw, 92vw';
      el.alt = img.alt || '';
      // The first is above the fold; the rest can wait until scrolled toward.
      el.loading = i === 0 ? 'eager' : 'lazy';
      el.decoding = 'async';
      stack.appendChild(el);
    });

    viewer.hidden = false;
    document.body.classList.add('pp-noscroll');
    stack.scrollTop = 0;
    viewer.querySelector('[data-pp-viewer-close]').focus();

    if (pushState !== false && location.hash !== '#' + slug) {
      history.pushState({ ppLook: slug }, '', '#' + slug);
    }
  };

  var close = function (pop) {
    if (viewer.hidden) return;
    viewer.hidden = true;
    document.body.classList.remove('pp-noscroll');
    stack.innerHTML = '';
    if (lastFocused) lastFocused.focus();
    if (!pop && location.hash) {
      history.pushState({}, '', location.pathname + location.search);
    }
  };

  document.querySelectorAll('[data-pp-look]').forEach(function (btn) {
    btn.addEventListener('click', function () { open(btn.dataset.ppLook); });
  });

  viewer.querySelector('[data-pp-viewer-close]').addEventListener('click', function () { close(); });

  // Backdrop click, but not on an image.
  viewer.addEventListener('click', function (e) {
    if (e.target === viewer || e.target === stack) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!viewer.hidden && e.key === 'Escape') close();
  });

  window.addEventListener('popstate', function () {
    var slug = location.hash.replace('#', '');
    if (slug && dataFor(slug)) { open(slug, false); } else { close(true); }
  });

  // Deep link: arriving with a hash opens that look directly.
  var initial = location.hash.replace('#', '');
  if (initial && dataFor(initial)) open(initial, false);
})();
